export const defaultSiteTabTitle = "Админка Kulturati";

// TODO!
// ? id6=концерт, куда его? как заполняется?
export const eventTypeIdSetsByKulturalGoal = process.env.REACT_APP_API_TYPE === "prod" ? {
        "theatre": [4,6,7,8,11],
        "musical_theatre": [1,2,5,9,10,12],
        "museum": [3],
    } : {
        "theatre": [4,7,8,9,10,11,12,13,14,17,19],
        "musical_theatre": [1,2,5,9,10,15,16,18,20,21],
        "museum": [3],
    }

export const settings = {
    useShortDatesInfo: true
}

export const inlineTipMargin = 4;